import TextField, { TextFieldVariants } from "@mui/material/TextField";
import { ComponentProps } from "../types";
import { CSSProperties, useMemo, useContext, useState, useEffect } from "react";
import DashboardPageContext from "../DashboardPageContext";
import { InputProps, Switch } from "@mui/material";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const [value, setValue] = useState<boolean>(() => (evaluteScript(component.properties["binding"]) as boolean) || false);
	const exeMode = useContext(ExecutionTypeContext);

	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		return style;
	}, [component, exeMode]);

	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context]);

	const locatorArgs = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
	}, [component, exeMode]);

	return (
		<>
			{value !== undefined && (
				<Switch
					key={component.id}
					style={style}
					{...args}
					checked={value}
					onChange={(event) => {
						setValue(event.target.checked);
						const script = component.properties["binding"] + "=" + event.target.checked;
						evaluteScript(script);
						updateContext(context);
					}}
					{...locatorArgs}
				/>
			)}
		</>
	);
}

export default Component;
